<template>
  <div>
    <vs-card style="border-radius: 20px;">
      <div class="mt-2" slot="header">
        <vs-row id="center">
          <h3 id="v" style="color: #111111">
            Download Sensor Data
          </h3>
          <h3 id="p" style="color: #111111">
            Download Sensor Data
          </h3>
          <vs-spacer />
          <!-- <vs-tooltip text="Print" position="top" >
        <vs-button radius   color="#333f50" type="line"   icon="print"></vs-button></vs-tooltip>&nbsp;&nbsp;
        <vs-tooltip text="Download a PDF" position="top" >
          <vs-button radius  color="#333f50" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>&nbsp;&nbsp;
          <vs-tooltip text="Export" position="top" >
          <vs-button radius  color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>&nbsp;&nbsp;&nbsp;&nbsp; -->
        </vs-row>
      </div>

      <!--Modals download-csv-->
      <b-modal id="bv-modal-example" centered hide-footer>
        <template #modal-title> <h3>Download .csv</h3></template>
        <div
          class="d-block container"
          style=" align-items: center;  display: flex;"
        >
          <b-container class="bv-example-row">
            <b-row>
              <!--startDate-->
              <b-col
                ><datetime v-model="mintime" input-id="Start Date">
                  <h6 for="startDate" slot="before">StartDate</h6>
                  <span class="description" slot="after"></span>
                  <template slot="button-cancel">
                    <fa :icon="['far', 'times']"></fa>
                    Cancel
                  </template>
                  <template slot="button-confirm">
                    Confirm
                  </template>
                </datetime></b-col
              >
              <!--endDate-->
              <b-col
                ><datetime
                  v-model="maxtime"
                  input-id="startDate"
                  @change="test"
                >
                  <h6 for="startDate" slot="before">End Date</h6>
                  <span class="description" slot="after"></span>
                  <template slot="button-cancel">
                    <fa :icon="['far', 'times']"></fa>
                    Cancel
                  </template>
                  <template slot="button-confirm">
                    Confirm
                  </template>
                </datetime></b-col
              >
              <!-- <b-col><vs-button color="primary" type="border">Primary</vs-button></b-col>-->
            </b-row>
          </b-container>
          <br />

          <vs-button type="filled" color="#333f50" @click="test"
            >Fetch Data</vs-button
          >
          <vs-button type="filled" color="#333f50">
            <download-csv
              :data="sensdata"
              :name="sensdata[0].sensorid + ' data.csv'"
            >
              Download
            </download-csv></vs-button
          >
        </div>
      </b-modal>
      <!--END Modals download-csv-->

      <vs-table
        search hoverFlat="false"
        :data="sensorlist"
        style="background-color: #F2F3F4 ; border-radius: 20px;"
      >
        <template slot="header">
          <div
            class="a"
            style="margin-left: 1%; width: auto; margin-top: 1%; margin-bottom: 1%; border-radius: 5px; "
          >
            <vs-dropdown>
              <h6 class="a-icon" href.prevent>
                Filters :
                {{ this.network }}
                <vs-icon class icon="expand_more" size="12px"></vs-icon>
              </h6>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in nwlist"
                  :key="item.id"
                  @click="actionchange(item.id, item.name)"
                >
                  {{ item.name }}</vs-dropdown-item
                >
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <vs-spacer />
        </template>
        <br />

        <template slot="thead">
          <vs-th style="padding: 0px" sort-key="name">
            <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
            Sensor Name
          </vs-th>
          <vs-th style="padding: 0px" sort-key="type">
            <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
            Sensor Type
          </vs-th>
          <vs-th style="padding: 0px">
            Send via E-mail
          </vs-th>
          <vs-th style="padding: 0px">
            Download
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].name }}
            </vs-td>
            <vs-td>
              {{ data[indextr].type }}
            </vs-td>
            <vs-td>
              <!-- <vs-button
                color="primary"
                type="line"
                icon="cloud_download"
                id="show-btn"
                disabled
                @click="$bvModal.show('bv-modal-example')"
                >Send via E-mail</vs-button> -->
                <vs-button
                color="primary"
                type="line"
                icon="cloud_download"
                id="show-btn"
                v-b-modal.sentmail
                @click="item2 = data[indextr]"
                >Send via E-mail</vs-button>
            </vs-td>
            <vs-td>
              <vs-button
                color="warning"
                type="line"
                icon="email"
                v-b-modal.repdownl
                @click="item = data[indextr]"
                >Download .csv</vs-button
              >
              <!-- <vs-button  color="warning" type="line" icon="email" @click="download(data[indextr])">Download .csv</vs-button> -->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
    <!-- <iframe src="https://g3.ipcamlive.com/player/player.php?alias=601914ed36f92" width="800px" height="600px" 
frameborder="0" allowfullscreen></iframe> -->
    <vs-prompt
      color="success"
      title="Download .csv"
      type="alert"
      buttonAccept="false"
      buttonCancel="false"
    >
      <div
        class="d-block container"
        style=" align-items: center;  display: flex;"
      >
        <b-container class="bv-example-row">
          <b-row>
            <!--startDate-->
            <b-col
              ><datetime v-model="mintime" input-id="Start Date">
                <h6 for="startDate" slot="before">StartDate</h6>
                <span class="description" slot="after"></span>
                <template slot="button-cancel">
                  <fa :icon="['far', 'times']"></fa>
                  Cancel
                </template>
                <template slot="button-confirm">
                  Confirm
                </template>
              </datetime></b-col
            >
            <!--endDate-->
            <b-col
              ><datetime v-model="maxtime" input-id="startDate" @change="test">
                <h6 for="startDate" slot="before">End Date</h6>
                <span class="description" slot="after"></span>
                <template slot="button-cancel">
                  <fa :icon="['far', 'times']"></fa>
                  Cancel
                </template>
                <template slot="button-confirm">
                  Confirm
                </template>
              </datetime></b-col
            >
            <!-- <b-col><vs-button color="primary" type="border">Primary</vs-button></b-col>-->
          </b-row>
        </b-container>
        <br />
        <vs-button type="filled" @click="test" color="#333f50">Fetch</vs-button>
        <vs-button
          type="filled"
          color="#333f50"
          class="ml-2"
          :disabled="!sensdata[1]"
        >
          <download-csv
            :data="sensdata"
            :name="item.name + ' ' + date + ' data.csv'"
          >
            Download
          </download-csv></vs-button
        >
      </div>
    </vs-prompt>

    <!-- sendmail -->
<b-modal
      id="sentmail"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #5fa74b">Send via E-mail</h4>
      </template>
      <vs-row class="mt-2" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          Start Date :
          <div style="padding: 20px; padding-left: 14px;  ">
            <datetime
              v-model="mintime2"
              input-id="Start Date"
              class="theme-orange"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="6"
          vs-sm="12"
          vs-xs="12"
        >
          End Date :
          <div style="padding: 20px; padding-left: 20px;  ">
            <datetime
              class="glyphicon glyphicon-cloud"
              v-model="maxtime2"
              input-id="startDate"
              type="datetime"
            />
          </div>
        </vs-col>
       
         </vs-row>
         <vs-row vs-w="12">
  <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
   
  </vs-col>
 
</vs-row><br>

    

      <vs-row class="ml-3 mt-2" vs-w="12">
        <vs-spacer />
        <vs-button
            :disabled="active == true"
            style="border-radius: 18px;"
            color="warning"
            @click="sentmail()"
            icon="search"
            type="filled"
            >Send E-mail</vs-button>
        <vs-button
          class="ml-2 mr-4"
          color="dark"
          type="flat"
          id="btncancel"
          @click="cancel()"
          >Cancel</vs-button
        >
      </vs-row>
    </b-modal>
    <b-modal
      id="repdownl"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #5fa74b">Download .csv</h4>
      </template>
      <vs-row class="mt-2" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          Start Date :
          <div style="padding: 20px; padding-left: 14px;  ">
            <datetime
              v-model="mintime"
              input-id="Start Date"
              class="theme-orange"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          End Date :
          <div style="padding: 20px; padding-left: 20px;  ">
            <datetime
              class="glyphicon glyphicon-cloud"
              v-model="maxtime"
              input-id="startDate"
              type="datetime"
            />
          </div>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="2"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-button
            :disabled="active == true"
            style="border-radius: 18px;"
            color="warning"
            @click="test()"
            icon="search"
            type="filled"
            >Check</vs-button
          >
        </vs-col> </vs-row
      ><br />

      <vs-row v-if="active == true" vs-w="12">
        <vs-col class="mt-2" vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
          Download .csv
        </vs-col>
        <vs-col vs-type="flex" vs-lg="8" vs-sm="12" vs-xs="12">
          <vs-col class="mt-2"
            >Start Date :
            {{ $moment(mintime).format('YYYY-MM-DD HH:mm:ss') }}
            <vs-col class="mt-2">Due Date : {{ $moment(maxtime).format('YYYY-MM-DD HH:mm:ss') }}</vs-col>
          </vs-col>
        </vs-col> </vs-row
      ><br />

      <vs-row class="ml-3 mt-3" vs-w="12">
        <vs-spacer />
        <vs-button
          @click="hidemodal()"
          v-if="active == true"
          :disabled="!sensdata[1]"
          style="border-radius: 18px;"
          color="primary"
          type="filled"
        >
          <download-csv
            :data="sensdata"
            :name="item.name + ' ' + date + ' data.csv'"
          >
            Download
          </download-csv></vs-button
        >
        <vs-button
          class="ml-2 mr-4"
          color="dark"
          type="flat"
          id="btncancel"
          @click="cancel()"
          >Cancel</vs-button
        >
      </vs-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Report",
  data: () => ({
    item: { name: "test" },
    nwlist: [],
    reportdownload: "",
    sensorlist: [],
    fields: ["id", "test"],
    network: "",
    sensdata: [{ sensorid: "" }],
    active: false,
    active2: false,
    mintime: null,
    maxtime: null,
    mintime2: null,
    maxtime2: null,
    value: "",
    date: "",
  }),
  
  methods: {
    hidemodal() {
      this.$bvModal.hide(repdownl);
    },
    cancel() {
      location.reload();
    },
    a() {
      // console.log(this.item);
    },

   sentmail(){
        // // console.log('hi')
        // // this.sendMailUrl = this.$url2 +"emailreport/" +this.item2.username +"/" + this.item2.type+"/"+ this.item2.serial_id+"/"+this.mintime2+"/"+this.maxtime2
        // this.$http.get(this.$url2 +"emailreport/" +this.item2.username +"/" + this.item2.type+"/"+ this.item2.serial_id+"/"+this.mintime2+"/"+this.maxtime2).then(response){
        // // console.log(response)
        // }
      this.$http.get(this.$url2 +"emailreport/" +this.item2.username +"/" + this.item2.type+"/"+ this.item2.serial_id+"/"+this.mintime2+"/"+this.maxtime2,{
      headers: {
      'Access-Control-Request-Method': '*',
      'Access-Control-Request-Headers': '*',
      'Access-Control-Allow-Origin': '*'
      },
      username: "admin",
      password: "admin",
      role: this.checkbox
      }).then((result) =>{
        // console.log(result);
        if(result.status == 200){
          // console.log("Email")
        }
      })
    },
   
          //   {
          //   headers: {
          //     'Access-Control-Request-Method': '*',
          //     'Access-Control-Request-Headers': '*',
          //     'Access-Control-Allow-Origin': '*'
          //   },
          //   username: "admin",
          //   password: "admin",
          //   role: this.checkbox
          //   }).then((result) =>{
          //     // console.log(result);
          //     // console.log("done")
          //   })
          // },

    test() {
      // console.log(this.item);
      if (this.maxtime == "" || this.mintime == "") {
        // // console.log('hi')
        this.$http
          .get(
            this.$url +
              "sensordata2/" +
              this.item.serial_id +
              "/" +
              this.item.gatewayid
          )
          .then((result) => {
            // eslint-disable-next-line no-console
            // console.log(result.data);
            this.sensdata = result.data;
          })
          .then(() => {
            this.active = true;
          });
      } else {
        var body = {
          column: "*",
          start: this.mintime,
          end: this.maxtime,
          id: this.item.serial_id,
          type: this.item.type,
          gid: this.item.gatewayid,
          lora: this.item.lora,
          mode: "report",
        };
        // console.log(body);
        this.$http
          .post(this.$url + "filtersensor", body)
          .then((result) => {
            // eslint-disable-next-line no-console
            // console.log(result.data);
            this.sensdata = result.data;
          })
          .then(() => {
            this.active = true;
          });
      }
    },
    async actionchange(id, name) {
      this.network = name;
      if (name == "All Network") {
        await this.$http
          .get(this.$url + "sensorid/" + this.$session.get("token"))
          .then((result) => {
            this.sensorlist = result.data;
          });
      } else {
        await this.$http
          .get(this.$url + "sensors/" + id + "/" + this.$session.get("token"))
          .then((result) => {
            this.sensorlist = result.data;
          });
      }
      // eslint-disable-next-line no-console
      // console.log(this.sensorlist);
    },
    link2(item) {
      this.$router.push({
        name: "SensorDashboard",
        params: {
          nwname: this.network,
          nwid: item.nwid,
          sensorid: item.serial_id,
          gatewayid: item.gatewayid,
          type: item.type,
        },
      });
    },
    download(item) {
      this.item = item;
      this.active = true;
      // if(this.maxtime == '' || this.mintime == '') {
      //   // console.log('hi')
      //   this.$http.get(this.$url+'sensordata1/'+item.serial_id+'/'+item.gatewayid).then((result) => {
      //   // eslint-disable-next-line no-console
      //     // console.log(result.data)
      //     this.sensdata = result.data
      //   }).then(() => {
      //     this.active = true
      //   })
      // }else{
      //   var body = {
      //     column: "*",
      //     start: this.mintime,
      //     end: this.maxtime,
      //     id: item.serial_id,
      //     type: item.type,
      //     gid: item.gatewayid,
      //     mode: 'report'
      //   }
      //   // console.log(body)
      //   this.$http.post(this.$url+'filtersensor', body).then((result) => {
      //   // eslint-disable-next-line no-console
      //     // console.log(result.data)
      //     this.sensdata = result.data
      //   }).then(() => {
      //     this.active = true
      //   })
      // }
    },
  },
  created() {
    this.date = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    this.$http
      .get(this.$url + "network/" + this.$session.get("token"))
      .then((result) => {
        this.nwlist = result.data;
        this.nwlist.unshift({ id: 0, name: "All Network" });
        this.network = result.data[0].name;
      });
    this.$http
      .get(this.$url + "sensorid/" + this.$session.get("token"))
      .then((result) => {
        this.sensorlist = result.data;
      });
  },
};
</script>
<style scoped>
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}

button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#center {
  display: flex;
  align-items: center;
}
#p {
  display: inline;
}
#v {
  display: none;
}
@media screen and (max-width: 600px) {
  .a {
    /* background: pink; */
    width: 200px;
  }
  #v {
    display: inline;
  }
  #p {
    display: none;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>
